module.exports = __webpack_public_path__ + "img/40_00_032_336.da53b8a8.jpg";